import React from "react";
import { TodoContext } from "../../Utils/TodoContext";
import './TodoCounter.css';

// class counterState {
//   public totalTodos: number;
//   public completedTodos: number;

//   constructor(data: counterState) {
//     this.totalTodos = data.totalTodos;
//     this.completedTodos = data.completedTodos;
//   }
// }

function TodoCounter() {
  const { totalTodos, completedTodos }: any = React.useContext(TodoContext);
  return (
    <h2 className="TodoCounter">You have accomplished {completedTodos} of your {totalTodos} todos!</h2>
  );
}

export { TodoCounter };